import React from 'react';
import PropTypes from 'prop-types';

import {Link, Typography} from 'views/components';

const GeneratedCustomUrl = (props) => {
  const {jobData, fullUrl, setFullUrl} = props;

  const baseUrl = `${process.env.REACT_APP_CAREGIVER_DOMAIN}/caregiver-application`;


  React.useEffect(() => {
    const generatedUrl = `${baseUrl}?job=${jobData.jobRn}`;

    setFullUrl(generatedUrl);
  }, [jobData.jobRn, baseUrl, setFullUrl]);

  return (
    <Typography
      sx={{
        fontSize: '13.5px',
        wordBreak: 'break-all',
        textAlign: 'left',
      }}
    >
      <Link
        href={fullUrl}
        target="_blank"
        rel="noopener"
        sx={{
          fontSize: '13.5px',
          wordBreak: 'break-all',
          textAlign: 'left',
        }}
        labelText={fullUrl}
      />
    </Typography>
  );
};

GeneratedCustomUrl.propTypes = {
  jobData: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  fullUrl: PropTypes.string,
  setFullUrl: PropTypes.func,
};

export default GeneratedCustomUrl;
